interface ClusterAddonParams {
  clusterName: string
  addonType: string
  version: string
  // Add-on settings, such as { etcdBackup: {...} } for the etcd backup add-on
  clusterSpec?: Record<string, unknown>
}

export const createKaapiClusterAddonBody = ({
  clusterName,
  addonType,
  version,
  clusterSpec,
}: ClusterAddonParams) => {
  return {
    apiVersion: 'core.barista.platform9.io/v1alpha1',
    kind: 'ClusterAddon',
    metadata: {
      name: `${addonType}-addon-${clusterName}`,
      annotations: {
        'projectsveltos.io/template': 'true',
      },
    },
    spec: {
      clusterID: clusterName,
      type: addonType,
      version,
      ...(clusterSpec ? { clusterSpec } : {}),
    },
  }
}
